module.exports = __webpack_public_path__ + "media/criteria.f8326c25.mp4";